import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { configurableProductsRouter } from './routing/configurableProductsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { configurableProductsAccessControl } from './access-control/configurableProductsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'configurable-products',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'configurable-products-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [configurableProductsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Catalog,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Configure product options and variants for items with multiple sizes, colors, or pack types (e.g., bottle sizes, color options)',
          labelId: 'configurableProductsDomain.title',
          // the name of the route the user should be brought to when clicking
          // on this navigation button
          route: 'configurable-products-show',
          // the accessControl configuration that determines if this nav item
          // should be displayed to the user
          accessControl: configurableProductsAccessControl,
          positionNavV2: 3,
          inToolPermissions: [],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
